import React from 'react'

import * as css from './SelectCaptadores.css'
import classNames from 'classnames/bind'
let cx = classNames.bind(css)

export class BotonRegion extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            actual: this.props.actual,
            clicked: this.props.buttonStatus,
        }

        this.handleClick = () => {
            if (this.state.clicked == false) {
                this.props.setStatusButton(this.props.value, 1)
                this.setState({ clicked: true, actua: this.props.actual })
            } else {
                this.props.setStatusButton(this.props.value, 0)
                this.setState({ clicked: false, actual: false })
            }
        }
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            actual: nextProps.actual,
            clicked: nextProps.buttonStatus,
        })
    }

    render() {
        return (
            this.props.disponible
                ? <button className={this.state.clicked ? (this.state.actual ? cx('region-actual') : cx('region-marcada')) : cx('region')}
                    title={this.props.title}
                    value={this.props.value}
                    onClick={this.handleClick.bind(this)}
                >
                    {this.props.numero}
                </button>
                : <button
                    className={cx('region')}
                    title={this.props.title}
                    value={this.props.value}
                    disabled
                >
                    {this.props.numero}
                </button>
        )
    }
}


// WEBPACK FOOTER //
// ./frontEnd/components/shared/BotonRegion.jsx